import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import IconRight from '@/assets/icons/icon-right.svg';
import PlusSm from '@/assets/icons/plus-sm.svg';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';

interface NoActiveHiringGoalProps {
  addHiringGoalUrl: string;
  onViewPastGoals: () => void;
}

export function NoActiveHiringGoal({
  addHiringGoalUrl,
  onViewPastGoals,
}: NoActiveHiringGoalProps) {
  return (
    <div className="flex w-full flex-col gap-3">
      <div className="flex w-full items-center justify-between gap-4">
        <Typography variant="body2" className="text-fx-neutral-600">
          <FormattedMessage
            defaultMessage="No active hiring goal"
            description="Empty state title when the opening has no active hire-by goal"
          />
        </Typography>
        <Button
          variant="ghost"
          className="text-fx-neutral-900 h-6 shrink-0 gap-1 p-0 font-medium hover:bg-white"
          onClick={onViewPastGoals}
        >
          <FormattedMessage
            defaultMessage="View past goals"
            description="Opens the hiring goals modal to browse past goals for this opening"
          />
          <img src={IconRight} alt="" aria-hidden="true" />
        </Button>
      </div>
      <div className="flex w-full items-center gap-2">
        <Typography
          variant="small1"
          className="text-fx-neutral-400 min-w-0 flex-1"
        >
          <FormattedMessage
            defaultMessage="Set a goal to track pacing against a target and date. Source will alert you if you fall behind."
            description="Empty state helper when the opening has no active hiring goal"
          />
        </Typography>
        <Button variant="secondary" size="sm" className="shrink-0" asChild>
          <Link to={addHiringGoalUrl} target="_blank">
            <img src={PlusSm} alt="" aria-hidden="true" />
            <FormattedMessage
              defaultMessage="Add hiring goal"
              description="Button: open WX to create a hiring goal in new tab"
            />
          </Link>
        </Button>
      </div>
    </div>
  );
}
